'use strict';

import config from 'config';
import thunkMiddleware from 'redux-thunk';
import {
  applyMiddleware,
  compose,
  createStore
} from 'redux';
import { syncHistory } from 'redux-simple-router';
import callAPIMiddleware from 'store/callAPIMiddleware';
import rootReducer from 'store/root.reducer';

function withDevTools (middleware) {
  const devTools = window.devToolsExtension
    ? window.devToolsExtension()
    : require('../components/devTools/devTools').default.instrument();
  return compose(middleware, devTools);
}

export default function configureStore ({ initialState = {}, history }) {
  // Sync with router via history instance (main.js)
  const routerMiddleware = syncHistory(history);

  // Compose final middleware and use devtools in debug environment
  let middleware = applyMiddleware(thunkMiddleware, callAPIMiddleware, routerMiddleware);
  if (config.appEnv === 'dev') middleware = withDevTools(middleware);

  // Create final store and subscribe router in debug env ie. for devtools
  const store = middleware(createStore)(rootReducer, initialState);
  if (config.appEnv === 'dev') routerMiddleware.listenForReplays(store, ({ router }) => router);

  if (module.hot) {
    module.hot.accept('./root.reducer', () => {
      const nextRootReducer = require('./root.reducer').default;

      store.replaceReducer(nextRootReducer);
    })
  }
  return store

}



// WEBPACK FOOTER //
// ./src/store/configureStore.js